<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>
    <h2 langkey="phAGBConfirmationDialog_Title"></h2>
    <div>
      <p class="content-desc" langkey="phAGBConfirmationDialog_Description"></p>
    </div>
    <div>
      <div class="content term-container">
        <div #privacyContent (click)="onShowTermsClick($event)" class="term__text" [innerHtml]="AGB_innerhtml"></div>
      </div>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <button mat-flat-button (click)="ConfirmAgb()">
              <span langkey="phAGBConfirmationDialog_AcceptBtn"> </span>
            </button>
          </div>
          <div class="ya-button-container">
            <button mat-stroked-button (click)="DenyAgb()">
              <span langkey="phAGBConfirmationDialog_DeclineBtn"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>